export const CREATE_BULLETIN_REQUEST = 'CREATE_BULLETIN_REQUEST';
export const CREATE_BULLETIN_SUCCESS = 'CREATE_BULLETIN_SUCCESS';
export const CREATE_BULLETIN_FAILED = 'CREATE_BULLETIN_FAILED';

export const PREVIEW_BULLETIN_SUCCESS = 'PREVIEW_BULLETIN_SUCCESS'

export const GET_BULLETIN_DRAFT_REQUEST = 'GET_BULLETIN_REQUEST';
export const GET_BULLETIN_DRAFT_SUCCESS = 'GET_BULLETIN_SUCCESS';
export const GET_BULLETIN_DRAFT_FAILED = 'GET_BULLETIN_FAILED';

export const UPDATE_BULLETIN_DRAFT_REQUEST = 'UPDATE_BULLETIN_DRAFT_REQUEST';
export const UPDATE_BULLETIN_DRAFT_SUCCESS = 'UPDATE_BULLETIN_DRAFT_SUCCESS';
export const UPDATE_BULLETIN_DRAFT_FAILED = 'UPDATE_BULLETIN_DRAFT_FAILED';

export const PUBLISHED_BULLETIN_STATUS_REQUEST =
  'PUBLISHED_BULLETIN_STATUS_REQUEST';
export const PUBLISHED_BULLETIN_STATUS_SUCCESS =
  'PUBLISHED_BULLETIN_STATUS_SUCCESS';
export const PUBLISHED_BULLETIN_STATUS_FAILED =
  'PUBLISHED_BULLETIN_STATUS_FAILED';

export const DRAFT_BULLETIN_ACTIVE_STATUS_REQUEST =
  'DRAFT_BULLETIN_ACTIVE_STATUS_REQUEST';
export const DRAFT_BULLETIN_ACTIVE_STATUS_SUCCESS =
  'DRAFT_BULLETIN_ACTIVE_STATUS_SUCCESS';
export const DRAFT_BULLETIN_ACTIVE_STATUS_FAILED =
  'DRAFT_BULLETIN_ACTIVE_STATUS_FAILED';

export const CLEAR_BULLETIN_SUCCESS = 'CLEAR_BULLETIN_SUCCESS';

export const SEARCH_BULLETIN_REQUEST = 'SEARCH_BULLETIN_REQUEST';
export const SEARCH_BULLETIN_SUCCESS = 'SEARCH_BULLETIN_SUCCESS';
export const SEARCH_BULLETIN_FAILED = 'SEARCH_BULLETIN_FAILED';

export const REMOVE_BULLETIN_REQUEST = 'REMOVE_BULLETIN_REQUEST';
export const REMOVE_BULLETIN_SUCCESS = 'REMOVE_BULLETIN_SUCCESS';
export const REMOVE_BULLETIN_FAILED = 'REMOVE_BULLETIN_FAILED';

export const previewBulletinDataAction = (data) => {
  return { type: PREVIEW_BULLETIN_SUCCESS, payload: data };
};

export const createBulletinDataAction = (data) => {
  return { type: CREATE_BULLETIN_REQUEST, payload: data };
};

export const getbulletinDraftDetailAction = (data) => {
  return { type: GET_BULLETIN_DRAFT_REQUEST, payload: data };
};

export const updateBulletinDraftDetailAction = (data) => {
  return { type: UPDATE_BULLETIN_DRAFT_REQUEST, payload: data };
};

export const publishedBulletinStatus = (data) => {
  return { type: PUBLISHED_BULLETIN_STATUS_REQUEST, payload: data };
};
export const searchBulletin = (data) => {
  return { type: SEARCH_BULLETIN_REQUEST, payload: data };
};

export const draftBulletinActiveStatus = (data) => {
  return { type: DRAFT_BULLETIN_ACTIVE_STATUS_REQUEST, payload: data };
};

export const RemoveBulletin = (data) => {
  return { type: REMOVE_BULLETIN_REQUEST, payload: data };
};
